import React from 'react';
// components
import MNPGV2 from "@/components/MainPageLayouts/components/MNPGV2";
// hooks
import useMainPageItems from '@/hooks/useMainPageItems';
// types
import { TFooterComponent } from './type';
import { isEmpty } from 'lodash';


const Footer = ( props:TFooterComponent ) => {
    console.log("Footer.rendered: ", props);

    const footerTemplates = useMainPageItems({mapLayoutName:"MNPGGRP_002"});

    if ( !footerTemplates || isEmpty(footerTemplates) ) return null;

    return (
        <footer className="footer-area footer-dark">
            <MNPGV2 templates={footerTemplates} mapLayoutName="MNPGGRP_002" />
        </footer>
    )
}

const Component = React.memo(Footer, (prevProps: TFooterComponent, nextProps: TFooterComponent) => {
    console.log("Footer.memo", { prevProps, nextProps });
    return true;
});

export default Component;
